// PaymentFlowDynamic.js
import React from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function PaymentFlowDynamic({
  amountLabel,        // string → “$3.20”   (display-only)
  clientSecret,
  setIsPurchasing,
  onPaymentSuccess,
  onCancel,
}) {
  const stripe   = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsPurchasing(true);

    const submitRes = await elements.submit();
    if (submitRes.error) {
      alert(submitRes.error.message);
      setIsPurchasing(false);
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      clientSecret,
      elements,
      redirect: "if_required",
    });

    if (error) {
      alert(`Payment failed: ${error.message}`);
      setIsPurchasing(false);
      return;
    }
    if (paymentIntent?.status === "succeeded") {
      onPaymentSuccess(paymentIntent);
      setIsPurchasing(false);
    }
  };

  return (
    <div style={{ width: "100%", maxHeight: "80vh", overflowY: "auto", padding: 10, paddingTop: 60 }}>
      <form onSubmit={handleSubmit} style={{ width: "100%" }}>
        <div style={{ marginBottom: 20, textAlign: "center", color: "white", fontSize: 18 }}>
          You’ll pay {amountLabel} to cover the balance
        </div>

        <PaymentElement />

        <button
          type="submit"
          style={{
            marginTop: 20,
            padding: 20,
            background: "#635bff",
            color: "#fff",
            fontSize: 16,
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            width: "100%",
          }}
          disabled={!stripe}
        >
          Pay&nbsp;Now
        </button>

        <button
          type="button"
          style={{
            marginTop: 10,
            padding: 10,
            background: "transparent",
            color: "#fff",
            border: "1px solid #fff",
            borderRadius: 4,
            cursor: "pointer",
            width: "100%",
          }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </form>
    </div>
  );
}
